import * as React from 'react';
import {Button, Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import warningImage from '../../assets/img/widget/warning.png';
import PropTypes from 'prop-types';
import HorizontalLine from "../Widget/HorizontalLine";
// import label from "../../message/Label";
import label from 'enqc-utilities/src/label/Label'

import MyCardImage from "../Card/MyCardImage";


export default class ConfirmReleaseVerificationCancelModal extends React.Component{


    render(){
        let {releaseVerification} = this.props
        return (
            <Modal
                centered={true}
                isOpen={this.props.showing}
                backdrop={true}>
                <ModalHeader className="text-center w-100 d-block bg-header">
                    <span className="w-100 text-center h3" block>{label.ConfirmCancellation}</span>
                </ModalHeader>
                <ModalBody>
                    <Card>
                        <CardBody style={{textAlign:'center'}}>
                            <MyCardImage style={{width:'240px'}} src={warningImage}/>
                        </CardBody>
                    </Card>
                    <br/>
                    <div style={{textAlign:'center'}}
                         dangerouslySetInnerHTML={{__html: label.YouWillPostponeReleaseWithReference_AreYouSure(releaseVerification.reference, label.Postponed)}} />
                </ModalBody>
                <HorizontalLine/>
                <ModalBody>
                    <Row>
                        <Col>
                            <Button color="warning" onClick={e=>{
                                this.props.cancelCallback()
                            }}>
                                {label.Cancel}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                className={"float-right"}
                                color="danger" onClick={e=>{
                                this.props.okCallback(releaseVerification)
                            }}>
                                {label.YesIamSure}
                            </Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        )
    }
}
ConfirmReleaseVerificationCancelModal.propTypes = {
    releaseVerification:PropTypes.object.isRequired,
    showing:PropTypes.bool.isRequired,
    okCallback:PropTypes.func.isRequired,
    cancelCallback:PropTypes.func.isRequired
}
